export const measureTabOffsets = (container: HTMLDivElement): number[] => {
	const children = container.children as HTMLCollectionOf<HTMLElement>;
	return Array.from({ length: children.length - 1 }, (_, i) => children[i].offsetLeft);
};
